/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RELATED_CONTENT_TYPES } from '../../../assets/constants/strings';

import '../text_wrapper.scss';
import SortButton from '../../Buttons/SortButton';

const RelatedContent = ({
  relatedContent,
  currentDocument,
  spStructure,
  isPreview,
}) => {
  //#region DATA SETUP
  // because we now have 4 levels of relationships, we need to check what to display on all levels

  const [allRelationships, setAllRelationships] = useState([]);

  const [documentRels, setDocumentRels] = useState([]);
  const [levelOneRels, setLevelOneRels] = useState([]);
  const [levelTwoRels, setLevelTwoRels] = useState([]);
  const [levelThreeRels, setLevelThreeRels] = useState([]);
  const [levelFourRels, setLevelFourRels] = useState([]);

  const [globalRelationships, setGlobalRelationships] = useState([]);
  const [displayRelationships, setDisplayRelationships] = useState([]);

  useEffect(() => {
    const allRelationships = [];
    if (!isPreview && relatedContent) {
      relatedContent.forEach((item) =>
        item.Relationships.forEach((relationship) => allRelationships.push(relationship))
      );
    }
    setAllRelationships(allRelationships);
  }, [relatedContent, isPreview]);

  useEffect(() => {
    setGlobalRelationships(allRelationships.filter((rel) => rel.TargetType === 'Global'));
    setDocumentRels(allRelationships.filter((rel) => rel.TargetType === 'Document'));
    setLevelOneRels(allRelationships.filter((rel) => rel.TargetType === 'LevelOne'));
    setLevelTwoRels(allRelationships.filter((rel) => rel.TargetType === 'LevelTwo'));
    setLevelThreeRels(allRelationships.filter((rel) => rel.TargetType === 'LevelThree'));
    setLevelFourRels(allRelationships.filter((rel) => rel.TargetType === 'LevelFour'));
  }, [allRelationships]);

  useEffect(() => {
    if (
      currentDocument.levelOne &&
      currentDocument.levelTwo &&
      spStructure
    ) {
      // logic to map the content to be displayed based on the relationships
      const display = [];

      // document level
      documentRels.forEach((rel) => {
        if (rel.TargetValue === currentDocument.id) {
          const content = relatedContent.filter(
            (content) => content.ID === rel.RelatedContentId
          )[0];
          if (display.filter((displayed) => content.ID === displayed.ID).length < 1)
            display.push({ ...content, displayLevel: rel.TargetType });
        }
      });

      if (currentDocument.levelFour) {
        // level four (optional)
        levelFourRels.forEach((rel) => {
          if (rel.TargetValue === currentDocument.levelFour.ID) {
            const content = relatedContent.filter(
              (content) => content.ID === rel.RelatedContentId
            )[0];
            if (display.filter((displayed) => content.ID === displayed.ID).length < 1)
              display.push({ ...content, displayLevel: spStructure.LevelFour });
          }
        });
      }

      if (currentDocument.levelThree) {
        // level three (optional)
        levelThreeRels.forEach((rel) => {
          if (rel.TargetValue === currentDocument.levelThree.ID) {
            const content = relatedContent.filter(
              (content) => content.ID === rel.RelatedContentId
            )[0];
            if (display.filter((displayed) => content.ID === displayed.ID).length < 1)
              display.push({ ...content, displayLevel: spStructure.LevelThree });
          }
        });
      }

      // level two (document category)
      levelTwoRels.forEach((rel) => {
        if (rel.TargetValue === currentDocument.levelTwo.ID) {
          const content = relatedContent.filter(
            (content) => content.ID === rel.RelatedContentId
          )[0];
          if (display.filter((displayed) => content.ID === displayed.ID).length < 1)
            display.push({ ...content, displayLevel: spStructure.LevelTwo });
        }
      });

      // level One (business unit)
      levelOneRels.forEach((rel) => {
        if (rel.TargetValue === currentDocument.levelOne.ID) {
          const content = relatedContent.filter(
            (content) => content.ID === rel.RelatedContentId
          )[0];
          if (display.filter((displayed) => content.ID === displayed.ID).length < 1)
            display.push({ ...content, displayLevel: spStructure.LevelOne });
        }
      });

      // visible globally
      globalRelationships.forEach((rel) => {
        const content = relatedContent.filter((content) => content.ID === rel.RelatedContentId)[0];
        if (display.filter((displayed) => content.ID === displayed.ID).length < 1)
          display.push({ ...content, displayLevel: 'Visible globally' });
      });

      setDisplayRelationships(display);
      setSortedArr(display);
    }
  }, [
    globalRelationships,
    documentRels,
    levelOneRels,
    levelTwoRels,
    levelThreeRels,
    levelFourRels,
    currentDocument,
    spStructure,
  ]);

  //#endregion

  //#region UI SETUP

  const [isAscending, setIsAscending] = useState(true);
  const [sortedArr, setSortedArr] = useState([]);

  // reusable function to not crowd the return unnecessarily
  const displayList = (list) =>
    list.map((content, index) => (
      <a
        key={index}
        href={content.RelatedContentUrl ? content.RelatedContentUrl : content.UploadContent}
        target="_blank"
        rel="noreferrer"
      >
        <div className="wf-card__item__wrapper">
          {RELATED_CONTENT_TYPES[content.ContentType]}
          <p
            title={`${content.Title} | ${content.displayLevel && content.displayLevel.match('globally')
              ? content.displayLevel
              : 'related to the current ' + content.displayLevel
              }`}
          >
            {content.Title}
          </p>
        </div>
      </a>
    ));

  //#endregion

  // no related links
  if (!displayRelationships || displayRelationships.length < 1) {
    return <p className="mb-0">No Related Content</p>;
  } else if (displayRelationships && displayRelationships.length < 2) {
    return <React.Fragment>{displayList(displayRelationships)}</React.Fragment>;
  } else {
    const handleOrder = () => {
      setIsAscending((currentState) => !currentState);

      setSortedArr(
        isAscending === true
          ? displayRelationships.sort((a, b) => (a.Title > b.Title ? 1 : -1))
          : displayRelationships.sort((a, b) => (a.Title < b.Title ? 1 : -1))
      );
    };

    return (
      <div className="sortable-wrapper">
        <div className="sortable-wrapper__list">{displayList(sortedArr)}</div>
        <div className="sortable-wrapper__button">
          <SortButton handleOrder={handleOrder} sort={isAscending === true ? '>' : '<'} small />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  relatedContent: state.client.relatedContent,

  spStructure: state.client.spStructure,

  currentDocument: state.document.currentDocument,

  isPreview: state.client.isPreview,
});

const connector = connect(mapStateToProps, null);

export default connector(RelatedContent);
